import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { prettyFloatMoney } from '@/helpers/utils';
import s from './index.module.scss';

export const MobileView = ({ data }) => {
  const { t } = useTranslation('reports');
  return (
    <div className={s.content}>
      <div className={s.row}>
        <div className="f-body-accent">{t('tax_data.interest_received')}</div>
        <div className="f-small-regular">
          {prettyFloatMoney(data?.interest_received, { decimalPlaces: 2 })}
        </div>
      </div>
      <div className={s.row}>
        <div className="f-body-accent">
          {t('tax_data.cash_bonuses_received')}
        </div>
        <div className="f-small-regular">
          {prettyFloatMoney(data?.cash_bonuses_received, { decimalPlaces: 2 })}
        </div>
      </div>
      <div className={s.row}>
        <div className="f-body-accent">
          {t('tax_data.non_cash_bonuses_invested')}
        </div>
        <div className="f-small-regular">
          {prettyFloatMoney(data?.non_cash_bonuses_invested, {
            decimalPlaces: 2,
          })}
        </div>
      </div>
      <div className={classnames(s.row, s.row_sub)}>
        <div className="f-body-accent">
          {t('tax_data.non_cash_bonuses_received')}
        </div>
        <div className="f-small-regular">
          {t('tax_data.transforms_into_cash', {
            amount: prettyFloatMoney(data?.non_cash_bonuses_received, {
              decimalPlaces: 2,
            }),
          })}
        </div>
      </div>
      <div className={classnames(s.row, s.row_sub)}>
        <div className="f-body-accent">
          {t('tax_data.non_cash_bonuses_expired')}
        </div>
        <div className="f-small-regular">
          {prettyFloatMoney(data?.non_cash_bonuses_expired, {
            decimalPlaces: 2,
          })}
        </div>
      </div>
      {data?.notes_text && (
        <div className={s.row}>
          <div className="f-body-accent">{t('tax_data.note')}</div>
          <div
            className={classnames(s.note, 'f-small-regular')}
            dangerouslySetInnerHTML={{ __html: data?.notes_text }}
          />
        </div>
      )}
    </div>
  );
};
